<div class="booking-loading">
  <header class="w-100"></header>

  <div class="pt-6 d-flex flex-column g-8 booking-loading-body desktop">
    <div class="d-flex flex-column g-4">
      <ds-skeleton class="radius-small" [width]="220" [height]="34" />

      <div class="d-flex flex-column g-2">
        <ds-skeleton class="radius-small" [width]="700" [height]="16" />
        <div class="d-flex g-5">
          <ds-skeleton class="radius-small" [width]="220" [height]="16" />
          <ds-skeleton class="radius-small" [width]="100" [height]="16" />
        </div>
      </div>
    </div>

    <ng-container *ngTemplateOutlet="itinerary" />

    <ng-container *ngTemplateOutlet="traveler" />

    <ng-container *ngTemplateOutlet="traveler" />

    <need-help-card />

    <footer></footer>
  </div>

  <div class="d-flex d-md-none flex-column booking-loading-body">
    <div
      class="d-flex flex-column gap-medium booking-loading-body-header gap-medium pr-4 pl-4 pb-3"
    >
      <div class="d-flex align-items-center g-3">
        <ds-button
          (click)="goBack()"
          variant="icon"
          size="s"
          icon="chevronLeft"
          label="Back"
          data-id="back"
        />
        <ds-skeleton class="radius-small" [width]="220" [height]="22" />
      </div>
      <div class="d-flex align-items-center g-4">
        <ds-skeleton class="radius-small" [width]="130" [height]="16" />
        <ds-skeleton class="radius-small" [width]="106" [height]="16" />
      </div>
    </div>

    <div class="d-flex flex-column g-8 p-4">
      <ng-container *ngTemplateOutlet="itinerary" />

      <ng-container *ngTemplateOutlet="traveler" />

      <ng-container *ngTemplateOutlet="traveler" />

      <need-help-card />
    </div>

    <footer class="pr-4 pl-4"></footer>
  </div>
</div>

<ng-template #traveler>
  <div class="d-flex flex-column g-4">
    <div class="d-flex flex-column gap-medium">
      <ds-skeleton class="radius-small" [width]="160" [height]="22" />
      <ds-skeleton class="radius-small" [width]="300" [height]="12" />
    </div>

    <div class="d-flex flex-column g-2 card w-100 p-4">
      <div class="d-flex g-5">
        <ds-skeleton class="radius-small" [width]="80" [height]="22" />
        <ds-skeleton class="radius-small" [width]="140" [height]="22" />
      </div>

      <div class="d-flex g-50">
        <ds-skeleton class="radius-small" [width]="50" [height]="12" />
        <ds-skeleton class="radius-small" [width]="170" [height]="12" />
      </div>
    </div>
  </div>
</ng-template>

<ng-template #itinerary>
  <div class="d-flex flex-column g-4">
    <div class="d-flex flex-column gap-medium">
      <ds-skeleton class="radius-small" [width]="160" [height]="22" />
      <ds-skeleton class="radius-small" [width]="300" [height]="12" />
    </div>

    <div class="d-flex flex-column g-4 card w-100 p-4">
      <div class="d-flex align-items-center g-6">
        <ds-skeleton class="round" [width]="32" [height]="32" />
        <ds-skeleton class="radius-small" [width]="230" [height]="16" />
      </div>

      <div class="d-flex g-6">
        <div class="d-flex flex-column align-items-center">
          <div class="pin">
            <ds-skeleton class="round" [width]="8" [height]="8" />
          </div>
          <ds-skeleton class="radius-small" [width]="1" [height]="88" />
          <div class="pin">
            <ds-skeleton class="round" [width]="8" [height]="8" />
          </div>
        </div>

        <div class="d-flex flex-column g-5">
          <div class="d-flex flex-column g-2">
            <div class="d-flex g-5 align-items-center">
              <ds-skeleton class="radius-small" [width]="80" [height]="22" />
              <ds-skeleton class="radius-small" [width]="140" [height]="22" />
            </div>
            <div class="d-flex g-50 align-items-center">
              <ds-skeleton class="radius-small" [width]="50" [height]="12" />
              <ds-skeleton class="radius-small" [width]="170" [height]="12" />
            </div>
          </div>

          <div class="d-flex g-40 align-items-center">
            <ds-skeleton class="radius-small" [width]="60" [height]="12" />
            <ds-skeleton class="radius-small" [width]="110" [height]="12" />
          </div>

          <div class="d-flex flex-column g-2">
            <div class="d-flex g-5 align-items-center">
              <ds-skeleton class="radius-small" [width]="80" [height]="22" />
              <ds-skeleton class="radius-small" [width]="140" [height]="22" />
            </div>
            <div class="d-flex g-50 align-items-center">
              <ds-skeleton class="radius-small" [width]="50" [height]="12" />
              <ds-skeleton class="radius-small" [width]="170" [height]="12" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
